export function orderStatusTranslate(status: string) {
	const statusesMap: Record<string, string> = {
		created: 'Чернетка',
		confirmed: 'Нове',
		rejected: 'Відхилено',
		approved: 'Підтверджено',
		packed: 'Збирається',
		packaged: 'Запаковано',
		shipped: 'Відправлено',
		received: 'Отримано',
	};
	return statusesMap[status] ?? 'Невідомо';
}
export function transactionStatusTranslate(status: string) {
	const statusesMap: Record<string, string> = {
		new: 'Нова',
		rejected: 'Відхилена',
		approved: 'Підтверджена',
		paid: 'Виплачено',
		received: 'Отримана',
	};
	return statusesMap[status] ?? status;
}
export function movementsStatusTranslate(status: string) {
	const statusesMap: Record<string, string> = {
		order: 'Оформлення',
		income: 'Замовлення',
		outcome: 'Повернення',
		write_off: 'Списання',
		pre_order: 'Предзамовлення',
	};
	return statusesMap[status] ?? status;
}
export function deliveryStatusTranslate(status: string) {
	const statusesMap: Record<string, string> = {
		self_delivery: 'Самовивіз',
		'self-delivery': 'Самовивіз',
		post: 'Нова пошта',
		courier: "Кур'єр по Києву",
	};
	return statusesMap[status] ?? status;
}
export function deliveryTypeTranslate(status: string) {
	const statusesMap: Record<string, string> = {
		door: 'Адреса',
		branch: 'Відділення',
	};
	return statusesMap[status] ?? status;
}
export function paymentMethodTranslate(method: string) {
	const methodsMap: Record<string, string> = {
		card: 'Карткою',
		after_pay: 'Накладений платіж в Новій пошті',
		cash: "Оплата кур'єру",
	};
	return methodsMap[method] ?? method;
}
export function invoiceStatusTranslate(status: string) {
	const statusesMap: Record<string, string> = {
		created: 'Чернетка',
		confirmed: 'Нове',
		rejected: 'Відхилено',
		approved: 'Підтверджено',
		packed: 'Збирається',
		packaged: 'Запаковано',
		shipped: 'Відправлено',
		received: 'Отримано',
	};
	return statusesMap[status] ?? 'Невідомо';
}

export type UserQualificationsType = {
	name: string;
	value: string;
	background: string;
};
export const userQualifications: UserQualificationsType[] = [
	{
		name: 'Невідомий',
		value: 'NON',
		background: 'linear-gradient(135deg, #d3d3d3, #a9a9a9)',
	},
	{
		name: 'Оптіма',
		value: 'OP',
		background: 'linear-gradient(135deg, #4facfe, #00f2fe)',
	},
	{
		name: 'Неактивний',
		value: 'NA',
		background: '#e4e2e4',
	},
	{
		name: 'Лояльний',
		value: 'LC',
		background: 'linear-gradient(135deg, #e4e2e4, #ffb008)',
	},
	{
		name: 'Активний',
		value: 'AD',
		background: '#ffb008',
	},
	{
		name: 'Менеджер',
		value: 'MN',
		background: 'linear-gradient(135deg, #004dc7, #0166fe)',
	},
	{
		name: 'Менеджер групи',
		value: 'MG',
		background: 'linear-gradient(135deg, #004dc7, #0166fe)',
	},
	{
		name: 'Менеджер мережі',
		value: 'MS',
		background: 'linear-gradient(135deg, #004dc7, #0166fe)',
	},
	{
		name: 'Лідер групи',
		value: 'LG',
		background: 'linear-gradient(135deg, #017d0f, #02aa14)',
	},
	{
		name: 'Лідер мережі',
		value: 'LN',
		background: 'linear-gradient(135deg, #017d0f, #02aa14)',
	},
	{
		name: 'Бізнес організатор',
		value: 'BO',
		background: 'linear-gradient(135deg, #017d0f, #02aa14)',
	},
	{
		name: 'Лідер організації',
		value: 'LO',
		background: 'linear-gradient(135deg, #ffeb0e, #ffd700)',
	},
	{
		name: 'Майстер',
		value: 'MA',
		background: 'linear-gradient(135deg, #ffeb0e, #ffd700)',
	},
	{
		name: 'Майстер майстрів',
		value: 'MM',
		background: 'linear-gradient(135deg, #ffeb0e, #ffd700)',
	},
	{
		name: 'Гранд майстер',
		value: 'GM',
		background: 'linear-gradient(135deg, #ff6600, #cc5200)',
	},
];
export function statusUserInRegList(status: string) {
	const statusesMap: Record<string, string> = {
		newbie: 'Новачок',
		optima: 'Реферал',
		loyalty: 'Без скидки',
		business: 'Партнер',
		manager: 'Менеджер',
		lider: 'Лідер',
		rejected: 'Видалений',
	};
	return statusesMap[status] ?? status;
}